import { APP_INITIALIZER, Provider } from '@angular/core';
import { isFromMobileApp } from '@app/core/helpers';
import { CloudMessagingService } from '@app/services/cloud-messaging.service';

export function initCloudMessagingFactory(svc: CloudMessagingService) {
  return () => {
    if (!isFromMobileApp()) return Promise.resolve();
    return svc.init();
  };
}

export const CLOUD_MESSAGING_INIT_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initCloudMessagingFactory,
  deps: [CloudMessagingService],
  multi: true,
};
